"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectProductTd = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var unitsList_1 = require("common/global/unitsList");
var lodash_1 = require("lodash");
var useMemoIfNotUndefined_1 = require("portal/hooks/useMemoIfNotUndefined");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var Option = antd_1.Select.Option;
var SelectProductTd = function (props) {
    var _a;
    var _b = props.cell, colSpan = _b.colSpan, path = _b.path, rowSpan = _b.rowSpan, value = _b.value;
    var onChangeV = props.onValueUpdate;
    var _c = (0, react_1.useState)(''), productNameIndex = _c[0], setProductNameIndex = _c[1];
    var trueStatus = true;
    var productsSnapshotFromFirebase = (0, firestore_1.useCollection)(collectionsRef_1.productsRef
        .where('nameIndex', 'array-contains', productNameIndex.toLowerCase().trim())
        .where('active', '==', trueStatus)
        .limit(50))[0];
    var productsSnapshot = (0, useMemoIfNotUndefined_1.useMemoIfNotUndefined)(productsSnapshotFromFirebase);
    var isValueUndefined = value.trim() === '' || value === null || value === undefined;
    var displayError = props.required && isValueUndefined && props.triedSubmitting;
    return ((0, jsx_runtime_1.jsx)("td", __assign({ style: props.style, className: index_modules_css_1.default.gridTd, colSpan: colSpan, rowSpan: rowSpan }, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ className: index_modules_css_1.default.selectCell, validateStatus: displayError ? 'error' : undefined }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ style: { width: '100%', height: '100%', borderColor: displayError ? '#FF0000' : 'none' }, onChange: function (productId) {
                    var _a, _b, _c;
                    var product = (_a = productsSnapshot === null || productsSnapshot === void 0 ? void 0 : productsSnapshot.docs) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.id === productId; });
                    (onChangeV || lodash_1.noop)(path, __assign(__assign({}, ((_b = product === null || product === void 0 ? void 0 : product.data()) !== null && _b !== void 0 ? _b : {})), { id: (_c = product === null || product === void 0 ? void 0 : product.id) !== null && _c !== void 0 ? _c : '' }));
                }, defaultValue: value, onSearch: function (e) { return setProductNameIndex(e); }, showSearch: true, optionFilterProp: "children" }, { children: (_a = productsSnapshot === null || productsSnapshot === void 0 ? void 0 : productsSnapshot.docs) === null || _a === void 0 ? void 0 : _a.map(function (products, key) {
                    var _a, _b, _c, _d;
                    var product = products === null || products === void 0 ? void 0 : products.data();
                    var title = "".concat((_a = product === null || product === void 0 ? void 0 : product.name) !== null && _a !== void 0 ? _a : "", "/ ").concat((_b = product === null || product === void 0 ? void 0 : product.description) !== null && _b !== void 0 ? _b : "", "/ ").concat((_d = (_c = unitsList_1.globalUnitsData[product === null || product === void 0 ? void 0 : product.unitId]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "");
                    return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: products.id, title: title }, { children: title }), key));
                }) })) })) })));
};
exports.SelectProductTd = SelectProductTd;
